import label from './radar.data.emphasis.label'
import itemStyle from './radar.data.emphasis.itemStyle'
import lineStyle from './radar.data.emphasis.lineStyle'
import areaStyle from './radar.data.emphasis.areaStyle'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "单个数据项样式的高亮设置。",
  type: "object",
  props: {
    label,
    itemStyle,
    lineStyle,
    areaStyle,
  },
}
